import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader } from '@livable/saas-react-components';
import { Button, Typography, Link } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CsvFileUploader from '../CsvFileUploader';
import { useStore } from 'src/stores';
import moment from 'moment';
import useAllocationUtilityStyles from '../../AllocationUtility/styles';
import SubmeterCsvTableModal from '../SubmeterCsvTableModal';
import SubmeterChargesErrorsTable from '../SubmeterChargesErrorsTable';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import { generateCsv, generateRedactedCsv } from 'src/pages/AllocationTablesPage/AllocationSubmeteredUtility/tools';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
const residentsSortField = 'Unitname';
const residentsSortBy = 'Asc';
const residentsSizeFrom = 1;
const residentsSizeMax = 100;
const residentsStatus = [RESIDENCY_STATUS_KEY_VALUES.FormerActive, RESIDENCY_STATUS_KEY_VALUES.FormerClosed, RESIDENCY_STATUS_KEY_VALUES.Current];
const ALLOCATION_METHOD_STRING = {
  BySubmeter: 'By Submeter'
};

// ? i18n
const SubmeterAllocationForm = observer(props => {
  const classes = useAllocationUtilityStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const propertyId = props.propertyId,
    utility = props.utility,
    utilityName = props.utilityName,
    setSentStatus = props.setSentStatus,
    sentStatus = props.sentStatus,
    propertyAddress = props.propertyAddress,
    allocationCycleId = props.allocationCycleId,
    utilityId = props.utilityId;
  const selectedBillingCycleId = store.allocations.selectedBillingCycleId;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    propertyUtilities = _useState2[0],
    setPropertyUtilities = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDisabled = _useState6[0],
    setIsDisabled = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    fileContents = _useState8[0],
    setFileContents = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    userInitialCsvFileId = _useState0[0],
    setUserInitialCsvFileId = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    userEditedCsvFileId = _useState10[0],
    setUserEditedCsvFileId = _useState10[1];
  const _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    uploadedFile = _useState12[0],
    setUploadedFile = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    dataToPassOver = _useState14[0],
    setDataToPassOver = _useState14[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    fileErrors = _useState16[0],
    setFileErrors = _useState16[1];
  const _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    chargeErrors = _useState18[0],
    setChargeErrors = _useState18[1];
  const _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    residenciesData = _useState20[0],
    setResidenciesData = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    curBuildingId = _useState22[0],
    setCurBuildingId = _useState22[1];
  const _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    applyChargesModalState = _useState24[0],
    setApplyChargesModalState = _useState24[1];
  const uploadRedactedFile = async fileBlob => {
    let uploadFileResult;
    if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
      uploadFileResult = await store.files.uploadFileViaPresignedUrlExperimentAsync.run({
        file: fileBlob,
        createdBy: store.account.userProfile.id
      });
    } else {
      uploadFileResult = await store.files.uploadFileAsync.run({
        file: fileBlob
      });
    }
    return uploadFileResult;
  };
  const getResidencies = async function (buildingId) {
    let residenciesArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let pageNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : residentsSizeFrom;
    try {
      const residenciesRequest = await store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.run({
        buildingId: buildingId,
        includeEmptyUnits: true,
        searchQuery: '',
        sortBy: residentsSortField,
        sortOrder: residentsSortBy,
        page: pageNumber,
        pageSize: residentsSizeMax,
        statuses: residentsStatus
      });
      if (residenciesRequest !== null && residenciesRequest !== void 0 && residenciesRequest.isSuccessful) {
        var _residenciesRequest$r;
        const responseUnitsCount = residenciesRequest === null || residenciesRequest === void 0 || (_residenciesRequest$r = residenciesRequest.response) === null || _residenciesRequest$r === void 0 ? void 0 : _residenciesRequest$r.unitsCount;
        const nextPageNumber = Math.ceil(responseUnitsCount / residentsSizeMax);

        // if we already had units, combine with the new ones
        const residencies = residenciesArray.length ? residenciesArray.concat(residenciesRequest.response.buildingResidency) : residenciesRequest.response.buildingResidency;
        if (nextPageNumber !== pageNumber && responseUnitsCount > residentsSizeMax) {
          // if next page is available, do the same again and pass results to function
          return await getResidencies(buildingId, residencies, nextPageNumber);
        }
        // if no next page, we are finished
        return residencies;
      }
    } catch (e) {
      console.log('Error fetching residencies', e.message);
    }
  };
  const getSubmeterFinalState = async () => {
    return store.allocations.postGetSubMeterFinalStateAsync.run({
      propertyId: propertyId,
      utilityId: utilityId,
      billingCycleId: selectedBillingCycleId
    });
  };
  const fetchData = async () => {
    var _singleElementOfArray;
    // get building data by property id
    const buildingsData = await store.buildings.getBuildingAsync.run({
      propertyId
    });
    if (!(buildingsData !== null && buildingsData !== void 0 && buildingsData.isSuccessful)) return;
    const currentBuildingId = (_singleElementOfArray = singleElementOfArray(buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.id;
    setCurBuildingId(currentBuildingId);

    // get unit residencies data by building id
    const residencies = await getResidencies(currentBuildingId);
    if (residencies) {
      setResidenciesData(residencies);
    }

    // get property utility providers data
    const propertyUtilitiesResp = await store.properties.getPropertyUtilityProvidersV3Async.run({
      propertyId
    });
    const utilitiesArr = [];
    if (propertyUtilitiesResp && propertyUtilitiesResp.isSuccessful) {
      (propertyUtilitiesResp.response || []).map(up => {
        (up.utilities || []).map(u => _objectSpread({}, u)).forEach(e => utilitiesArr.push(e));
      });
      setPropertyUtilities(utilitiesArr);
    }
    const postGetSubMeterFinalStateAsyncResp = await getSubmeterFinalState();
    if (postGetSubMeterFinalStateAsyncResp !== null && postGetSubMeterFinalStateAsyncResp !== void 0 && postGetSubMeterFinalStateAsyncResp.isSuccessful) {
      var _postGetSubMeterFinal;
      if (!(postGetSubMeterFinalStateAsyncResp !== null && postGetSubMeterFinalStateAsyncResp !== void 0 && (_postGetSubMeterFinal = postGetSubMeterFinalStateAsyncResp.response) !== null && _postGetSubMeterFinal !== void 0 && _postGetSubMeterFinal.length)) return;
      const updatedFileContents = postGetSubMeterFinalStateAsyncResp.response.map(r => {
        var _residencies$find;
        const residencyData = _objectSpread({}, (_residencies$find = residencies === null || residencies === void 0 ? void 0 : residencies.find(rr => rr.accountId === r.residentAccountId)) !== null && _residencies$find !== void 0 ? _residencies$find : {});
        return _objectSpread(_objectSpread({}, r), {}, {
          residencyData: residencyData,
          fullName: residencyData.fullname,
          startReadDate: moment(r.startMeterDateOnly, 'YYYY-mm-dd').format('MM/DD/YYYY'),
          endReadDate: moment(r.endMeterDateOnly, 'YYYY-mm-dd').format('MM/DD/YYYY'),
          utilityUnit: r.unitsOfMeasure,
          utilityCharge: r.allocationCharge,
          serviceDays: r.serviceDaysInPeriod
        });
      });
      setFileContents(null);
      setFileContents(updatedFileContents);
      setSentStatus(true);
    }
  };
  const saveChargesHistory = async () => {
    const chargesConfig = (fileContents || []).map(ch => {
      return {
        unitName: String(ch.unitName),
        residentAccountId: ch.accountId,
        isProcessed: true,
        startMeterRead: parseFloat(ch.startMeterRead),
        endMeterRead: parseFloat(ch.endMeterRead),
        startMeterDateOnly: moment(ch.startReadDate).format('YYYY-MM-DD'),
        endMeterDateOnly: moment(ch.endReadDate).format('YYYY-MM-DD'),
        serviceDaysInPeriod: parseInt(ch.serviceDays),
        meterRate: parseFloat(ch.meterRate),
        meterUsage: parseFloat(ch.meterUsage),
        unitsOfMeasure: ch.utilityUnit,
        allocationCharge: parseFloat(ch.utilityCharge)
      };
    });
    const createAllocationChargesAsyncResp = await store.allocations.createAllocationChargesAsync.run({
      propertyId,
      utilityId,
      buildingId: curBuildingId,
      allocationCycleId,
      billingCycleId: selectedBillingCycleId,
      userInitialCsvFileId,
      userEditedCsvFileId,
      submeterCharges: chargesConfig
    });
    if (createAllocationChargesAsyncResp !== null && createAllocationChargesAsyncResp !== void 0 && createAllocationChargesAsyncResp.isSuccessful) {
      console.log('createAllocationChargesAsyncResp', createAllocationChargesAsyncResp);
      // TO DO : chargesHistoryResult?.isSuccessful
    }
  };
  const postChargeTransactions = async rawChargesData => {
    var _rawChargesData$, _resp$response;
    const chargeErrorsInner = [];
    const data = {
      propertyId: ((_rawChargesData$ = rawChargesData[0]) === null || _rawChargesData$ === void 0 ? void 0 : _rawChargesData$.propertyId) || '',
      chargeTransactions: rawChargesData.map(item => {
        const tx = {
          amount: +item.amount,
          type: item.type,
          utilityId: item.utilityId,
          propertyUtilityId: item.propertyUtilityId,
          notes: item.notes,
          memo: item.memo,
          notifyResident: item.notifyResident,
          title: item.title,
          propertyId: item.propertyId,
          userAccountId: item.userAccountId
        };
        if (item.appfolioChargeOnDate) {
          tx.appfolioChargeOnDate = item.appfolioChargeOnDate;
        }
        return tx;
      })
    };
    const resp = await store.transaction.postBulkCustomChargeAsync.run(data);
    if (resp && resp !== null && resp !== void 0 && resp.response && (resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 || (_resp$response = _resp$response.result) === null || _resp$response === void 0 ? void 0 : _resp$response.length) > 0) {
      var _resp$response2;
      resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 || _resp$response2.result.map(i => {
        if (!i.isCreated) {
          var _rawChargesData$find, _rawChargesData$find2;
          const d = _objectSpread(_objectSpread({}, i === null || i === void 0 ? void 0 : i.chargeTransaction), {}, {
            name: (_rawChargesData$find = rawChargesData.find(el => {
              var _i$chargeTransaction;
              return el.userAccountId === (i === null || i === void 0 || (_i$chargeTransaction = i.chargeTransaction) === null || _i$chargeTransaction === void 0 ? void 0 : _i$chargeTransaction.userAccountId);
            })) === null || _rawChargesData$find === void 0 ? void 0 : _rawChargesData$find.name,
            number: (_rawChargesData$find2 = rawChargesData.find(el => {
              var _i$chargeTransaction2;
              return el.userAccountId === (i === null || i === void 0 || (_i$chargeTransaction2 = i.chargeTransaction) === null || _i$chargeTransaction2 === void 0 ? void 0 : _i$chargeTransaction2.userAccountId);
            })) === null || _rawChargesData$find2 === void 0 ? void 0 : _rawChargesData$find2.number
          });
          chargeErrorsInner.push(d);
        }
      });
      setChargeErrors(chargeErrorsInner);
    }
    return chargeErrorsInner;
  };
  const applyChargesActionHandler = async _ref => {
    let action = _ref.action,
      objectToPassOver = _ref.objectToPassOver;
    setApplyChargesModalState(false);
    if (action === 'submit') {
      setIsLoading(true);
      await postChargeTransactions(objectToPassOver);
      await saveChargesHistory();
      setSentStatus(true);
      await fetchData();
      setIsDisabled(true);
      setIsLoading(false);
    }
  };
  const getSubmeterTransactionTitle = (utilityData, tableRow) => {
    const meterReadStart = typeof tableRow.startMeterRead !== 'undefined' ? Number(tableRow.startMeterRead) : '';
    const meterReadEnd = typeof tableRow.endMeterRead !== 'undefined' ? Number(tableRow.endMeterRead) : '';
    const costMultiplier = typeof tableRow.meterRate !== 'undefined' ? Number(tableRow.meterRate).toFixed(2) : '';
    const servicePhone = typeof tableRow.servicePhoneNumber !== 'undefined' ? tableRow.servicePhoneNumber : '';
    const providerName = typeof tableRow.utilityProviderName !== 'undefined' ? tableRow.utilityProviderName : '';
    return "".concat(utilityName, " ").concat(ALLOCATION_METHOD_STRING[utilityData.allocationMethod], ", Service Period: ").concat(tableRow.startReadDate, " - ").concat(tableRow.endReadDate, ", ").concat(providerName ? '(' + providerName + ')' : '', " ").concat(meterReadStart || meterReadEnd ? 'Readings: ' + meterReadStart + ' - ' + meterReadEnd : '', ", Usage: ").concat(tableRow.meterUsage, " (").concat(tableRow.utilityUnit, ") ").concat(costMultiplier ? 'Rate: ' + costMultiplier : '', " ").concat(servicePhone ? 'Service Phone: ' + servicePhone : '', ".");
  };
  const transformCsvData = sourceCsv => {
    const result = (sourceCsv || []).map(row => {
      const propertyUtility = propertyUtilities.find(e => e.utilityId === utility.utilityId);
      return {
        amount: row.utilityCharge,
        memo: '',
        notes: '',
        notifyResident: false,
        propertyId: propertyId,
        propertyUtilityId: !!propertyUtility && Object.keys(propertyUtility).length && typeof propertyUtility.id !== 'undefined' ? propertyUtility.id : '',
        title: getSubmeterTransactionTitle(propertyUtility, row),
        type: 'Utility',
        userAccountId: row.accountId,
        utilityId: utility.utilityId,
        number: row.unitName,
        name: row.fullName
      };
    });
    setDataToPassOver(result);
  };
  const prepareRedactedFileBlod = async () => {
    const data = generateRedactedCsv(fileContents);
    const proposedFileName = "".concat(propertyAddress, "_redacted.csv");
    const fileData = new Blob([data], {
      type: 'application/octet-stream',
      name: proposedFileName
    });
    const uploadedFileResult = await uploadRedactedFile(fileData);
    if (uploadedFileResult !== null && uploadedFileResult !== void 0 && uploadedFileResult.isSuccessful) {
      setUserEditedCsvFileId(uploadedFileResult.response);
    }
  };
  const applyChargesClickHandler = event => {
    event.preventDefault();
    transformCsvData(fileContents);
    // We need to upload redacted file if it was edited (some rows has isEdited = true)
    if (fileContents.some(r => r.isEdited)) {
      prepareRedactedFileBlod();
    }
    setApplyChargesModalState(true);
  };
  const fileSelectCallback = async contents => {
    setIsLoading(true);
    setIsDisabled(true);
    if (contents && Object.keys(contents).length) {
      const fileName = contents.fileName,
        csvData = contents.csvData,
        errors = contents.errors;
      setUploadedFile(fileName);
      setFileContents(csvData);
      setFileErrors(errors);
      if (typeof contents.fileResponse !== 'undefined') {
        // assume that Successful response will give us a string or something not undefined
        setUserInitialCsvFileId(contents.fileResponse);
      }
      transformCsvData(csvData);
    } else {
      setUploadedFile(null);
      setFileContents([]);
    }
    setIsLoading(false);
    setIsDisabled(false);
  };
  const getModalBody = () => {
    const amountsArr = (dataToPassOver || []).map(item => item.amount);
    const amount = amountsArr.length ? amountsArr.reduce((prev, next) => Number(prev) + Number(next)) : 0;
    const chargeType = 'charge';
    return /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      color: "light"
    }, t('post_charge_modal.confirm_posting', {
      amount: '$' + Number(amount).toFixed(2),
      chargeType: chargeType
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.amountLine
    }, dataToPassOver.map(i => /*#__PURE__*/React.createElement("div", {
      key: i.unitMeterId,
      className: classes.unit
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: ''
    }, "Unit: ", i.number, ' ', /*#__PURE__*/React.createElement("span", null, ' ', "- ", i.name, " - ", '$' + Number(i.amount).toFixed(2)), /*#__PURE__*/React.createElement("p", null, "(", i.type, ": ", i.title, ")"))))));
  };
  const getModalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, "".concat(utilityName, " Allocated ").concat(utility.allocationMethod));
  const generateCsvTemplate = async event => {
    event.preventDefault();
    event.stopPropagation();
    const filename = propertyAddress ? "".concat(propertyAddress.replace(/ /g, '_'), ".csv") : "".concat(propertyId, ".csv");
    const data = generateCsv(residenciesData);
    if (!data) return;
    const encodedUri = window.URL.createObjectURL(new Blob([data], {
      type: 'application/octet-stream'
    }));
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  useEffect(() => {
    fetchData();
  }, [selectedBillingCycleId]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocationForm,
    "data-tut": "reactour__allocation-form"
  }, !sentStatus && /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Upload CSV reads'), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body6",
    component: "p",
    marginBottom: "8px"
  }, 'Upload csv submeter reads to auto-fill the fields below and press Apply.'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body6"
  }, ' ', "( You can", ' ', /*#__PURE__*/React.createElement(Link, {
    href: '',
    onClick: generateCsvTemplate
  }, "generate and download CSV template here"), ' ', ")")), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(uploadedFile ? 'attached' : '', " ").concat(classes.attachFile)
  }, /*#__PURE__*/React.createElement(CsvFileUploader, {
    callback: fileSelectCallback,
    disabled: isDisabled,
    label: 'Attach CSV sub meter reads',
    tooltipText: "".concat(t('allocations.livable_transparency'), " ").concat(t('allocations.you_share_bill')),
    isDisabledParent: isDisabled,
    isPreviewForm: true,
    noPreview: true,
    residenciesData: residenciesData && residenciesData.length ? residenciesData : []
  })))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), (uploadedFile || !!fileContents) && (sentStatus || !isDisabled) && /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.visibilitySetting
  }, /*#__PURE__*/React.createElement(SubmeterCsvTableModal, {
    key: JSON.stringify(fileContents),
    fileContents: fileContents || [],
    saveCallback: setFileContents,
    sentStatus: sentStatus
  }))), chargeErrors && chargeErrors.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.visibilitySetting
  }, /*#__PURE__*/React.createElement(SubmeterChargesErrorsTable, {
    chargeErrors: chargeErrors
  }))), !sentStatus && uploadedFile && /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent,
    style: {
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldsSm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.applyChargesButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled || !dataToPassOver.length,
    onClick: applyChargesClickHandler,
    variant: "contained",
    'custom-attribute': '501-Submeter-allocation-form'
  }, 'Apply charges'), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    headerText: 'Post charge(s)',
    subTitleText: getModalSubTitle,
    bodyComponent: getModalBody(),
    externalIsOpen: applyChargesModalState,
    callBack: applyChargesActionHandler,
    objectToPassOver: dataToPassOver,
    customTrigger: null
  }))))));
});
export default SubmeterAllocationForm;